import styles from './LicenseLogo.module.scss';

const LicenseLogo = () => {
    return <div className={styles.licenseLogo}>©WhoRiddle 2024</div>;
};

export default LicenseLogo;
